// @ts-check

import moment from "moment";

/**
 * @typedef {Object} ReportItemData
 * @property {string|number} id
 * @property {string} studyuuid
 * @property {string} patient
 * @property {string} filename
 * @property {string} uploadtime
 */
export class ReportItem {
  /**
   * @param {any} data
   */
  constructor(data) {
    this.id = data.id;
    this.studyuuid = data.studyuuid;
    this.patient = data.patient;
    this.filename = data.filename;
    this.uploadtime = data.uploadtime;
  }
  get reportDate() {
    return moment(this.uploadtime, "X").format("DD/MM/YYYY");
  }
}
